import { render, staticRenderFns } from "./activity-session-attendee-form.vue?vue&type=template&id=b3009bca&scoped=true&"
import script from "./activity-session-attendee-form.vue?vue&type=script&lang=ts&"
export * from "./activity-session-attendee-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3009bca",
  null
  
)

export default component.exports